<template>
  <v-dialog v-model="dialogDelete" max-width="500px">
    <DeleteCard
      v-if="!blockedMessage"
      title="Doriți să ștergeți acest utilizator?"
      @cancel="cancelDelete"
      @confirm="confirmDelete"
    />
    <!-- an account with history stays for the record: offer to block it instead -->
    <v-card v-else width="480px" class="confirm">
      <div class="confirm__icon" aria-hidden="true"><v-icon>mdi-account-lock-outline</v-icon></div>
      <p class="confirm__title">Utilizatorul nu poate fi șters</p>
      <p class="confirm__text">
        {{ blockedMessage }}<template v-if="!canBlock"> Contul este deja blocat.</template>
      </p>
      <div class="confirm__actions">
        <v-btn text large @click="cancelDelete">Închide</v-btn>
        <v-btn v-if="canBlock" large color="error" depressed :loading="working" @click="blockAccount">
          <v-icon left>mdi-account-lock-outline</v-icon>Blochează contul
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { deleteUser, updateUser } from "./api.js";
import DeleteCard from "@/components/elements/DeleteCard.vue";

export default {
  props: {
    user: Object,
  },
  components: {
    DeleteCard,
  },
  data() {
    return {
      dialogDelete: false,
      blockedMessage: "",
      working: false,
    };
  },
  computed: {
    // table rows carry the state as text
    canBlock() {
      return !!this.user && this.user.isActive === "Activ";
    },
  },
  methods: {
    show() {
      this.blockedMessage = "";
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
    },
    async confirmDelete() {
      try {
        if (
          this.user.idnp === "2009030001638" &&
          this.user.roleId.role === "admin"
        ) {
          this.dialogDelete = false;
          this.$emit("error", "Nu puteți șterge adminul principal.");
          return;
        }
        await deleteUser(this.user.id);
        this.$emit("updateUserData");
        this.dialogDelete = false;
        this.$emit("success", "Utilizatorul a fost șters");
      } catch (error) {
        console.error("Error deleting user:", error);
        if (error.response && error.response.status === 409) {
          this.blockedMessage = error.response.data.message;
          return;
        }
        this.$emit("error", error);
        this.dialogDelete = false;
      }
    },
    async blockAccount() {
      this.working = true;
      try {
        await updateUser({ id: this.user.id, isActive: false });
        this.$emit("updateUserData");
        this.$emit("success", "Contul a fost blocat");
        this.dialogDelete = false;
      } catch (error) {
        console.error("Error blocking user:", error);
        this.$emit("error", error);
      } finally {
        this.working = false;
      }
    },
  },
};
</script>

<style scoped>
.confirm {
  padding: 26px 26px 20px;
}
.confirm__icon .v-icon {
  font-size: 40px;
  color: var(--brick);
}
.confirm__title {
  margin: 10px 0 8px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.3;
  color: var(--ink);
}
.confirm__text {
  margin: 0 0 22px;
  color: var(--ink-2);
}
.confirm__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}
</style>
